export default "__VITE_ASSET__ZAXfkSQu__"